export default function AboutSection() {
  return (
    <section id="about" className="relative py-20 md:py-28 px-6 md:px-10 bg-background-50 overflow-hidden">
      <div className="max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-4">
            <span className="text-foreground-400 text-xs tracking-widest uppercase font-medium">
              / About GTBuy
            </span>
          </div>

          <div className="lg:col-span-8">
            <p className="text-foreground-800 font-heading text-2xl md:text-[28px] font-light leading-relaxed">
              gtbuyspreadsheet.living is an independent SEO navigation portal built to help users discover verified product category links and spreadsheet sourcing platforms. We connect you directly to kaspreadsheet.com&apos;s curated categories — no middlemen, no clutter.
            </p>
            <p className="text-foreground-500 text-base leading-relaxed mt-6 max-w-2xl">
              Our mission is simple: provide a clean, fast, and trustworthy gateway for anyone looking to explore spreadsheet-based product sourcing. Every category link is hand-verified, and all external links open securely in new tabs so you never lose your place.
            </p>

            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mt-12">
              <div className="flex -space-x-3">
                {['shield-check', 'refresh', 'link', 'eye', 'lock', 'star'].map((icon, i) => (
                  <div
                    key={i}
                    className="w-12 h-12 rounded-full bg-background-100 border-2 border-background-50 flex items-center justify-center"
                  >
                    <i className={`ri-${icon}-line text-foreground-500 text-lg`}></i>
                  </div>
                ))}
              </div>
              <div>
                <span className="inline-flex items-center gap-1.5 text-accent-500 text-sm font-semibold">
                  <span className="w-2 h-2 rounded-full bg-accent-500"></span>
                  Verified Sources
                </span>
                <p className="text-foreground-600 text-sm mt-1">Trusted by 10,000+ users worldwide</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}